export default __webpack_public_path__ + "44d0b1dbf484b055782c7fd2c4781679.svg";